module.exports = __webpack_public_path__ + "img/stick_activites_activite_junior.5057d5fd.svg";